// Maps a stored article icon name → a lucide-react component (with a fallback).
import {
    BookOpen, Compass, FileText, LogIn, ShieldCheck, GraduationCap,
    HelpCircle, ClipboardList, Users, Building, AlertTriangle, Wrench,
} from "lucide-react";

const MAP = {
    BookOpen, Compass, FileText, LogIn, ShieldCheck, GraduationCap,
    HelpCircle, ClipboardList, Users, Building, AlertTriangle, Wrench,
};

export const ICON_CHOICES = Object.keys(MAP);

export function articleIcon(name) {
    return MAP[name] || BookOpen;
}
